// Copyright (c) 2021 Deere & Company
import './index.scss';

import { AgGridReact } from 'ag-grid-react';
import PropTypes from 'prop-types';
import React from 'react';

const defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true
};

const AgGridReactComponent = props => {

    const sizeClass = ( props.rowData && props.rowData.length > 10 ) ? 'fixed-height-table' : '';
    return (

        <div className={`atp-ag-grid ag-theme-balham ag-theme-popupbg ${sizeClass}`}>
            <AgGridReact
                key={props.rowData.length}
                enableCellTextSelection={true}
                domLayout={sizeClass === '' ? 'autoHeight' : 'normal'}
                {...props}
                defaultColDef={{ ...defaultColDef, ...props.defaultColDef }}
            />
        </div>

    );

};

AgGridReactComponent.displayName = 'AgGridReactComponent';

AgGridReactComponent.propTypes = {
    rowData: PropTypes.array.isRequired,
    defaultColDef: PropTypes.object
};

export default AgGridReactComponent;
